/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { useLabel } from '@/wpt-lib/pdf/useData';

const ContentCreation = ({
    lookupSubject,
    lookupSubjectCode,
    teachingSubjectCourseType,
    contentForNewOrExistingSubject,
}: Partial<{
    lookupSubject: string;
    lookupSubjectCode: string;
    teachingSubjectCourseType: string;
    contentForNewOrExistingSubject: string;
}>) => (
    <>
        <Row>
            <ValueCell single label="Subject" value={`${lookupSubjectCode ?? ''} ${lookupSubject ?? ''}`} />
            <ValueCell
                single
                label="Short/Course Type"
                value={useLabel('teachingSubjectCourseType', teachingSubjectCourseType ?? '')}
            />
            <ValueCell
                single
                label="New/Existing"
                value={contentForNewOrExistingSubject === 'existingSubject' ? 'Existing' : 'New'}
            />
        </Row>
    </>
);
export default ContentCreation;
